import { ImageSection } from "@domain/lms/course/courseSection";
import { SectionController } from "@ui/pages/lms/courseEditorPage/courseEditorController/sectionController";

export class ImageSectionController extends SectionController<ImageSection> {}
